(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Brand switcher and Jockey-style menu interactions.
  (() => {
    const storageKey = 'shopify-header-brand';
    const SHEET_DURATION = 320;
    const DRAWER_DURATION = 320;
    const CART_DRAWER_DURATION = 340;
    const MENU_DURATION = 220;
    const SWITCH_DURATION = 220;
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const refreshHeaderHeight = () => {
      const sectionHeader = document.querySelector('.section-header');
      if (sectionHeader) {
        document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
      }
    };

    const getPath = (value) => {
      try {
        const url = new URL(value || '/', window.location.origin);
        return url.pathname.replace(/\/+$/, '') || '/';
      } catch (error) {
        return '/';
      }
    };

    const isCurrentPath = (value) => getPath(value) === getPath(window.location.href);

    const getBrandLink = (scope, brand) => {
      const option = scope.querySelector(`[data-header-brand-option][data-brand="${brand}"]`);
      return option?.dataset.brandLink || option?.getAttribute('href') || '';
    };

    const storeBrand = (brand) => {
      try {
        window.localStorage.setItem(storageKey, brand);
      } catch (error) {
        console.warn('Storage access denied:', error);
      }
    };

    const getInitialBrand = (scope, liquidBrand, storedBrand) => {
      const classicPath = getPath(getBrandLink(scope, 'classic') || '/');
      const freshonPath = getPath(getBrandLink(scope, 'freshon') || '/pages/freshon');
      const currentPath = getPath(window.location.href);

      if (currentPath === classicPath) return 'classic';
      if (currentPath === freshonPath || currentPath.startsWith(`${freshonPath}/`)) return 'freshon';

      return storedBrand || liquidBrand || 'classic';
    };

    const closeDisclosure = (details, immediate = false) => {
      if (!details) return;

      window.clearTimeout(details._headerMenuTimer);

      if (immediate) {
        details.open = false;
        details.classList.remove('is-closing');
        return;
      }

      if (!details.open) return;

      details.classList.add('is-closing');
      details._headerMenuTimer = window.setTimeout(() => {
        details.open = false;
        details.classList.remove('is-closing');
      }, MENU_DURATION);
    };

    const closeHeaderMenuDisclosures = (scope, except = null, immediate = false) => {
      scope.querySelectorAll('.header-brand-menu__disclosure').forEach((details) => {
        if (details !== except) closeDisclosure(details, immediate);
      });
    };

    const openDisclosure = (details) => {
      if (!desktopQuery.matches || !details) return;

      const menu = details.closest('[data-header-brand-menu]') || document;
      closeHeaderMenuDisclosures(menu, details);
      window.clearTimeout(details._headerMenuTimer);
      details.open = true;
      details.classList.remove('is-closing');
    };

    const bindHeaderMenus = (scope) => {
      scope.querySelectorAll('.header-brand-menu__disclosure').forEach((details) => {
        if (details.dataset.headerMenuBound === 'true') return;

        const summary = details.querySelector('summary');
        const hoverTarget = details.closest('.header-brand-menu__item') || details;
        details.dataset.headerMenuBound = 'true';

        hoverTarget.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'touch') openDisclosure(details);
        });

        hoverTarget.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'touch') closeDisclosure(details);
        });

        details.addEventListener('focusin', () => openDisclosure(details));

        details.addEventListener('focusout', (event) => {
          if (!details.contains(event.relatedTarget)) closeDisclosure(details);
        });

        summary?.addEventListener('click', (event) => {
          if (!desktopQuery.matches) return;

          // If the parent title link was clicked, let it navigate normally.
          if (event.target.closest('a[href]')) return;

          event.preventDefault();
          if (details.open && !details.classList.contains('is-closing')) {
            closeDisclosure(details);
          } else {
            openDisclosure(details);
          }
        });
      });
    };

    const updateBrandMenus = (scope, brand, animate = true) => {
      scope.querySelectorAll('[data-header-brand-menu]').forEach((menu) => {
        const isActive = menu.dataset.headerBrandMenu === brand;
        window.clearTimeout(menu._brandMenuTimer);

        if (!animate) {
          menu.hidden = !isActive;
          menu.classList.toggle('is-switching', false);
          closeHeaderMenuDisclosures(menu, null, true);
          return;
        }

        if (isActive) {
          menu.hidden = false;
          menu.classList.add('is-switching');
          requestAnimationFrame(() => {
            menu.classList.remove('is-switching');
          });
        } else if (!menu.hidden) {
          menu.classList.add('is-switching');
          closeHeaderMenuDisclosures(menu, null, true);
          menu._brandMenuTimer = window.setTimeout(() => {
            menu.hidden = true;
            menu.classList.remove('is-switching');
          }, SWITCH_DURATION);
        } else {
          menu.classList.remove('is-switching');
        }
      });
    };

    const updateBrandDrawers = (scope, brand) => {
      scope.querySelectorAll('[data-header-brand-drawer-menu]').forEach((menu) => {
        const isActive = menu.dataset.headerBrandDrawerMenu === brand;
        menu.hidden = !isActive;

        if (!isActive) {
          menu.querySelectorAll('details[open]').forEach((details) => {
            details.open = false;
          });
        }
      });
    };

    const setBrand = (scope, brand, persist = true, animate = true) => {
      const switcher = scope.querySelector('[data-header-brand-switcher]');
      if (!switcher || !brand) return;

      const changedBrand = switcher.dataset.selectedBrand !== brand;
      switcher.dataset.selectedBrand = brand;

      scope.querySelectorAll('[data-header-brand-option]').forEach((option) => {
        const isActive = option.dataset.brand === brand;
        option.classList.toggle('is-active', isActive);

        if (isActive) {
          option.setAttribute('aria-current', 'true');
        } else {
          option.removeAttribute('aria-current');
        }
      });

      updateBrandMenus(scope, brand, animate && changedBrand);
      updateBrandDrawers(scope, brand);

      if (persist) {
        storeBrand(brand);
      }

      if (!switcher.classList.contains('is-ready')) {
        requestAnimationFrame(() => {
          switcher.classList.add('is-ready');
          scope.classList?.remove('header-wrapper--brand-loading');
        });
      } else {
        scope.classList?.remove('header-wrapper--brand-loading');
      }
      refreshHeaderHeight();
    };

    const closeSheet = (scope, immediate = false) => {
      const switcher = scope.querySelector('[data-header-brand-switcher]');
      const sheet = scope.querySelector('[data-header-brand-sheet]');
      const trigger = scope.querySelector('[data-header-brand-trigger]');

      if (!sheet) return;

      window.clearTimeout(sheet._headerBrandSheetTimer);
      switcher?.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-brand-sheet-open');
      if (sheet.contains(document.activeElement)) trigger?.focus();

      if (immediate || sheet.hidden) {
        sheet.classList.remove('is-open', 'is-closing');
        sheet.hidden = true;
        return;
      }

      sheet.classList.remove('is-open');
      sheet.classList.add('is-closing');
      sheet._headerBrandSheetTimer = window.setTimeout(() => {
        sheet.hidden = true;
        sheet.classList.remove('is-closing');
      }, SHEET_DURATION);
    };

    const openSheet = (scope) => {
      const switcher = scope.querySelector('[data-header-brand-switcher]');
      const sheet = scope.querySelector('[data-header-brand-sheet]');
      const trigger = scope.querySelector('[data-header-brand-trigger]');

      if (!sheet) return;

      closeDrawer(scope, true);
      window.clearTimeout(sheet._headerBrandSheetTimer);
      sheet.hidden = false;
      sheet.classList.remove('is-closing');
      switcher?.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('header-brand-sheet-open');

      requestAnimationFrame(() => {
        sheet.classList.add('is-open');
      });

      setTimeout(() => {
        sheet.querySelector('.is-active[data-header-brand-option]')?.focus();
      }, 120);
    };

    const closeDrawer = (scope, immediate = false) => {
      const drawer = scope.querySelector('[data-header-brand-drawer]');
      const trigger = scope.querySelector('[data-header-brand-drawer-trigger]');

      if (!drawer) return;

      window.clearTimeout(drawer._headerBrandDrawerTimer);
      trigger?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-brand-drawer-open');
      if (drawer.contains(document.activeElement)) trigger?.focus();

      if (immediate || drawer.hidden) {
        drawer.classList.remove('is-open', 'is-closing');
        drawer.hidden = true;
        return;
      }

      drawer.classList.remove('is-open');
      drawer.classList.add('is-closing');
      drawer._headerBrandDrawerTimer = window.setTimeout(() => {
        drawer.hidden = true;
        drawer.classList.remove('is-closing');
      }, DRAWER_DURATION);
    };

    const openDrawer = (scope) => {
      const drawer = scope.querySelector('[data-header-brand-drawer]');
      const trigger = scope.querySelector('[data-header-brand-drawer-trigger]');

      if (!drawer) return;

      closeSheet(scope, true);
      window.clearTimeout(drawer._headerBrandDrawerTimer);
      drawer.hidden = false;
      drawer.classList.remove('is-closing');
      trigger?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('header-brand-drawer-open');

      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });
    };

    document.querySelectorAll('[data-header-brand-switcher]').forEach((switcher) => {
      if (switcher.dataset.brandSwitcherBound === 'true') return;

      const scope = switcher.closest('.header-wrapper') || document;
      let storedBrand = null;

      try {
        storedBrand = window.localStorage.getItem(storageKey);
      } catch (error) {
        storedBrand = null;
      }

      const liquidBrand = switcher.dataset.selectedBrand || 'classic';
      const initialBrand = getInitialBrand(scope, liquidBrand, storedBrand);

      switcher.dataset.brandSwitcherBound = 'true';
      bindHeaderMenus(scope);
      setBrand(scope, initialBrand, false, false);
      storeBrand(initialBrand);

      scope.querySelectorAll('[data-header-brand-option]').forEach((option) => {
        option.addEventListener('click', (event) => {
          const brand = option.dataset.brand;
          const brandLink = option.dataset.brandLink || option.getAttribute('href');
          const sheet = option.closest('[data-header-brand-sheet]');

          // On desktop let the browser follow the link normally. Updating the
          // selected brand before navigation briefly exposed the destination
          // menu and underline on the current page.
          if (!sheet) {
            if (brandLink && !isCurrentPath(brandLink)) storeBrand(brand);
            return;
          }

          // The mobile sheet needs time to close, but its selected state must
          // still be rendered only by the destination page after its URL loads.
          event.preventDefault();
          closeSheet(scope);

          if (brandLink && !isCurrentPath(brandLink)) {
            storeBrand(brand);
            window.setTimeout(() => {
              window.location.assign(brandLink);
            }, SHEET_DURATION);
          }
        });
      });

      scope.querySelector('[data-header-brand-trigger]')?.addEventListener('click', () => {
        const sheet = scope.querySelector('[data-header-brand-sheet]');
        const isOpen = sheet && !sheet.hidden && sheet.classList.contains('is-open');

        if (isOpen) {
          closeSheet(scope);
        } else {
          openSheet(scope);
        }
      });

      scope.querySelector('[data-header-brand-drawer-trigger]')?.addEventListener('click', () => {
        const drawer = scope.querySelector('[data-header-brand-drawer]');
        const isOpen = drawer && !drawer.hidden && drawer.classList.contains('is-open');

        if (isOpen) {
          closeDrawer(scope);
        } else {
          openDrawer(scope);
        }
      });

      scope.querySelectorAll('[data-header-brand-drawer-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          closeDrawer(scope);
        });
      });

      scope.querySelectorAll('[data-header-brand-drawer] a[href]').forEach((link) => {
        link.addEventListener('click', () => {
          closeDrawer(scope);
        });
      });

      scope.querySelectorAll('[data-header-brand-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          closeSheet(scope);
        });
      });

      scope.querySelector('.header-brand-sheet__scrim')?.addEventListener('click', (event) => {
        if (event.target === event.currentTarget) {
          closeSheet(scope);
        }
      });
    });

    const closeCartDrawer = (immediate = false) => {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

      window.clearTimeout(drawer._jockeyCartTimer);
      document.body.classList.remove('jockey-cart-drawer-open');

      if (immediate || drawer.hidden) {
        drawer.classList.remove('is-open', 'is-closing');
        drawer.hidden = true;
        return;
      }

      drawer.classList.remove('is-open');
      drawer.classList.add('is-closing');
      drawer._jockeyCartTimer = window.setTimeout(() => {
        drawer.hidden = true;
        drawer.classList.remove('is-closing');
      }, CART_DRAWER_DURATION);
    };

    const openCartDrawer = () => {
      const drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return;

      document.querySelectorAll('[data-header-brand-switcher]').forEach((switcher) => {
        const scope = switcher.closest('.header-wrapper') || document;
        closeSheet(scope, true);
        closeDrawer(scope, true);
      });

      window.clearTimeout(drawer._jockeyCartTimer);
      drawer.hidden = false;
      drawer.classList.remove('is-closing');
      document.body.classList.add('jockey-cart-drawer-open');

      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });
    };

    document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openCartDrawer();
      });
    });

    document.querySelectorAll('[data-cart-drawer-close]').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        closeCartDrawer();
      });
    });

    document.querySelectorAll('[data-cart-drawer-quantity]').forEach((quantitySelect) => {
      quantitySelect.addEventListener('change', () => {
        quantitySelect.form?.submit();
      });
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-header-brand-menu]').forEach((menu) => {
        if (!menu.contains(event.target)) closeHeaderMenuDisclosures(menu);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-header-brand-switcher]').forEach((switcher) => {
        const scope = switcher.closest('.header-wrapper') || document;
        closeSheet(scope);
        closeDrawer(scope);
      });
      closeCartDrawer();
      closeHeaderMenuDisclosures(document);
    });

    desktopQuery.addEventListener('change', () => {
      if (!desktopQuery.matches) closeHeaderMenuDisclosures(document, null, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
